import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { defaults } from 'lodash-es';
import { SearchView } from './application-settings.service';
import { SubscriptionLevel, UserInfo } from '../auth/models/user';
import { Precision } from '../application-settings/components/general/general.component';

export interface UserConfig {
  searchOption?: SearchView;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private currentApiKey: Observable<string>;
  private currentApiSubject: BehaviorSubject<string>;
  private userAFSetSubject: BehaviorSubject<[]>;
  private selectedAFSetSubject = new BehaviorSubject<number[]>([]);
  readonly afstore$: Observable<any> = this.selectedAFSetSubject.asObservable();

  getUser() {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  getSearchOptions() {
    return JSON.parse(sessionStorage.getItem('searchView'));
  }
  setUserAPIKey(apiKey: any) {
    // store Api Key of current loggedIn user
    localStorage.setItem('currentApiKey', apiKey);
    this.currentApiSubject.next(apiKey);
    this.currentApiKey = this.currentApiSubject.asObservable();
  }
  getUserApiKey() {
    return this.currentApiSubject.value ? this.currentApiSubject.value : '';
  }
  setuserAFSets(afsets: []) {
    localStorage.setItem('userAFSets', JSON.stringify(afsets));
    this.userAFSetSubject.next(afsets);
  }
  getuserAFSets() {
    return this.userAFSetSubject.value ? this.userAFSetSubject.value : null;
  }
  updateAfSetBySelection(afSets: number[], page) {
    afSets = afSets ? afSets : [];
    const totalAFSets = this.getuserAFSets();
    if (totalAFSets?.length === afSets?.length) {
      afSets = [-1];
    }
    const userCfg = this.getUserCfg();
    userCfg.afSetIDs = afSets;
    userCfg.selectedPage = page ? page : 1;
    this.updateUserCfg(userCfg);
    this.selectedAFSetSubject.next(afSets);
  }

  getSelectedAFSets() {
    return this.selectedAFSetSubject.value
      ? this.selectedAFSetSubject.value
      : null;
  }

  getStorageKey(): string {
    const userInfo = this.getUser();
    return `userCfg${this.hashCode(userInfo?.userId, userInfo?.accountId)}`;
  }

  getUserCfg() {
    const storageKey = this.getStorageKey();
    const userCfg = localStorage.getItem(storageKey);
    if (userCfg !== null && userCfg !== 'undefined') {
      const obj = JSON.parse(userCfg);
      return obj;
    }
    const user: UserInfo = JSON.parse(localStorage.getItem('currentUser'));
    const cfg = this.getDefaultUserCfg(user);
    this.setUserCfg(cfg);
    return cfg;
  }

  getDefaultUserCfg(user: UserInfo) {
    const customPlaceEnable = localStorage.getItem('isLicensedContentTools');
    const userCfg = {
      afSetIDs: [-1],
      selectedPage: 1,
      searchDefaultValue: {
        includePlaces: false,
        poiTypes: null,
        excludeTypes: null,
        includeTypes:
          user?.subscriptionLevel === SubscriptionLevel.PREMIUM
            ? null
            : ['City', 'State', 'Zip'],
        noOfMaxResults: 10,
        useCustomPlaces:
          customPlaceEnable === 'true'
            ? user?.subscriptionLevel === SubscriptionLevel.PREMIUM
              ? true
              : null
            : false,
        countries: null,
        states: null,
        useMapCenter: null,
        radiusFromCurrentLonLat: null,
        precision: Precision?.Hundredths,
      },
      mapStyle: 'transportation',
      mapLayers: {
        Traffic: false,
        TrafficIncident: false,
        TrafficCamera: false,
        WeatherRadar: false,
        WeatherCloud: false,
        WeatherAlert: false,
        RoadSurface: false,
        TruckRestriction: false,
        Buildings3D: false,
        PointsOfInterest: false,
        Places: true,
      },
    };
    return userCfg;
  }

  setUserCfg(config) {
    const storageKey = this.getStorageKey();
    localStorage.setItem(storageKey, JSON.stringify(config));
  }

  updateUserCfg(config) {
    const storageKey = this.getStorageKey();
    const val = JSON.stringify(defaults(config, this.getUserCfg()));
    localStorage.setItem(storageKey, val);
  }

  resetUserCfg() {
    const storageKey = this.getStorageKey();
    const user: UserInfo = JSON.parse(localStorage.getItem('currentUser'));
    localStorage.setItem(
      storageKey,
      JSON.stringify(this.getDefaultUserCfg(user))
    );
    return this.getUserCfg();
  }

  hashCode(a, b) {
    const num = 3 * a + 7 * b;
    const str = num.toString();
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) + hash + char; /* hash * 33 + c */
    }
    return hash;
  }
  constructor() {
    this.currentApiSubject = new BehaviorSubject<string>(
      localStorage.getItem('currentApiKey')
    );
    this.userAFSetSubject = new BehaviorSubject<any>(
      JSON.parse(localStorage.getItem('userAFSets'))
    );
  }
}
